export default __webpack_public_path__ + "static/media/weeman.c6e96781.png";